/**
 * Action types
 */

import { createTypes } from 'reduxsauce'
import { IComponentState } from '../root.types'
import { Map } from '../../application/models/map/map'
// import { IComponentState, IPaginator, ISearch } from '../root.types'

export const RelevanceTypes = createTypes(`

    LOAD_RELEVANCE_REQUEST
    LOAD_RELEVANCE_SUCCESS
    LOAD_RELEVANCE_FAILURE
`,
    {
        prefix: '@relevance/'
    }
)

/**
 * State type
 */
export interface IRelevanceState {
    readonly list: IListState
}

export interface IListState extends IComponentState {
    readonly relevance: Map[]
}
